<template>
  <div>
    <v-flex>
      <v-dialog v-model="dialog.zoom"
        @keydown.esc="dialog.zoom = false"
        :fullscreen="dialog.fullscreen"
        width="1450"
        persistent
        scrollable>
        <v-card 
          class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span v-if="selected.zoom_array.length > 0"
              class="mt-1 ml-1">
              Data Dukung ({{ selected.zoom_array[selected.zoom_index].title }})
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.zoom = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text v-if="selected.zoom_array.length > 0"
            class="py-0 pa-4">
            <v-row>
              <v-col
                cols="12"
                md="4">
                <v-card
                  flat>
                  <v-card-text
                    class="px-0 pt-0">
                    <v-divider
                      style="border: 3px solid #ff64ad;
                          border-radius: 50px;
                          width: 100px;" />
                    
                    <div
                      class="body-1 font-weight-bold black--text my-2">
                      Data Pengaju / Pelapor
                    </div>

                    <div
                      class="mt-4 mb-6">
                      <v-avatar 
                        size="125"
                        style="box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;">
                        <v-img
                          width="125"
                          height="125"
                          alt="vuetify"
                          :src="detail.pelapor_image.length < 1 ? require('@/assets/image/member-default.jpg') : detail.pelapor_image">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#ff64ad">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
                    </div>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        Nama Lengkap
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.pelapor_fullname }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        NIK
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_pelapor_nik }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        Email
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_is_mandiri ? detail.pelapor_email : detail.pelapor_extra.instansi_email }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        Telepon
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_is_mandiri ? detail.pelapor_phone : detail.pelapor_extra.instansi_phone }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        Tipe Ajuan
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_is_online ? 'Online' : 'Offline' }}
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="4"
                        class="py-0">
                        Kategori Ajuan
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_pelapor_role_name }}
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    class="px-0 pb-0">
                    <v-divider
                      style="border: 3px solid #ff64ad;
                          border-radius: 50px;
                          width: 100px;" />
                    
                    <div
                      class="body-1 font-weight-bold black--text my-2">
                      Data Ajuan
                    </div>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        Nama Lengkap
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_data_ajuan.field.nama_lengkap }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        NIK
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_data_ajuan.field.nik }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        Jenis Ajuan
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_layanan_kode }} - {{ detail.ja_judul }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        Alasan
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_keterangan === ''  ? '-' : detail.ajuan_keterangan }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="4"
                        class="py-0">
                        Kelurahan
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_kelurahan_name === ''  ? '-' : detail.ajuan_kelurahan_name }}
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="4"
                        class="py-0">
                        Kecamatan
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0">
                        : {{ detail.ajuan_kecamatan_name === ''  ? '-' : detail.ajuan_kecamatan_name }}
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col
                cols="12"
                md="8">
                <v-card 
                  flat
                  style="border-radius: 10px;">
                  <v-carousel
                    cycle
                    interval="500000"
                    prev-icon="mdi-arrow-left-thick"
                    next-icon="mdi-arrow-right-thick"
                    show-arrows-on-hover
                    :height="dialog.fullscreen ? '89vh' : '77vh'"
                    v-model="selected.zoom_index">
                    <v-carousel-item
                      v-for="(item, index) in selected.zoom_array"
                      :key="index">
                      <div v-if="!dialog.fullscreen"
                        class="on_hover_rotate text-center">
                        <v-img
                          :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out;`"
                          contain
                          width="100%"
                          height="70vh"
                          alt="vuetify"
                          :src="item.file">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#ff64ad">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <div
                          class="on_hover_btn">
                          <v-btn 
                            @click="rotateLeft"
                            elevation="0"
                            color="#b2b2b2"
                            fab
                            small
                            class="mx-4 white--text">
                            <v-icon>mdi-restore</v-icon>
                          </v-btn>

                          <v-btn 
                            @click="rotateRight"
                            elevation="0"
                            color="#b2b2b2"
                            fab
                            small
                            class="mx-4 white--text">
                            <v-icon>mdi-reload</v-icon>
                          </v-btn>
                        </div>
                      </div>

                      <div v-if="dialog.fullscreen"
                        class="on_hover_rotate text-center">
                        <v-zoomer
                          :doubleClickToZoom="true"
                          style="width: 100%; height: 92vh; cursor: pointer;">
                          <v-img 
                            :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out; width: 100%;`"
                            style="object-fit: contain; width: 100%; height: 100%;"
                            contain
                            alt="vuetify"
                            :src="item.file">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="#ff64ad">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-zoomer>

                        <div
                          class="on_hover_btn">
                          <v-btn 
                            @click="rotateLeft"
                            elevation="0"
                            color="#b2b2b2"
                            fab
                            small
                            class="mx-4 white--text">
                            <v-icon>mdi-restore</v-icon>
                          </v-btn>

                          <v-btn 
                            @click="rotateRight"
                            elevation="0"
                            color="#b2b2b2"
                            fab
                            small
                            class="mx-4 white--text">
                            <v-icon>mdi-reload</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-carousel-item>
                  </v-carousel>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- <v-dialog v-model="dialog.zoom"
        @keydown.esc="dialog.zoom = false"
        :fullscreen="dialog.fullscreen"
        width="1000"
        persistent
        scrollable>
        <v-card 
          class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span v-if="selected.zoom_array.length > 0"
              class="mt-1 ml-1">
              Data Dukung ({{ selected.zoom_array[selected.zoom_index].title }})
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.zoom = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text v-if="selected.zoom_array.length > 0"
            class="pt-2 pa-4">
            <v-card 
              flat
              style="border-radius: 10px;">
              <v-carousel
                cycle
                interval="500000"
                prev-icon="mdi-arrow-left-thick"
                next-icon="mdi-arrow-right-thick"
                show-arrows-on-hover
                :height="dialog.fullscreen ? '92vh' : '70vh'"
                v-model="selected.zoom_index">
                <v-carousel-item
                  v-for="(item, index) in selected.zoom_array"
                  :key="index">
                  <div v-if="!dialog.fullscreen"
                    class="on_hover_rotate text-center">
                    <v-img
                      :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out;`"
                      contain
                      width="100%"
                      height="70vh"
                      alt="vuetify"
                      :src="item.file">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="#ff64ad">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <div
                      class="on_hover_btn">
                      <v-btn 
                        @click="rotateLeft"
                        elevation="0"
                        color="#b2b2b2"
                        fab
                        small
                        class="mx-4 white--text">
                        <v-icon>mdi-restore</v-icon>
                      </v-btn>

                      <v-btn 
                        @click="rotateRight"
                        elevation="0"
                        color="#b2b2b2"
                        fab
                        small
                        class="mx-4 white--text">
                        <v-icon>mdi-reload</v-icon>
                      </v-btn>
                    </div>
                  </div>

                  <div v-if="dialog.fullscreen"
                    class="on_hover_rotate text-center">
                    <v-zoomer
                      :doubleClickToZoom="true"
                      style="width: 100%; height: 92vh; cursor: pointer;">
                      <v-img 
                        :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out; width: 100%;`"
                        style="object-fit: contain; width: 100%; height: 100%;"
                        contain
                        alt="vuetify"
                        :src="item.file">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#ff64ad">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-zoomer>

                    <div
                      class="on_hover_btn">
                      <v-btn 
                        @click="rotateLeft"
                        elevation="0"
                        color="#b2b2b2"
                        fab
                        small
                        class="mx-4 white--text">
                        <v-icon>mdi-restore</v-icon>
                      </v-btn>

                      <v-btn 
                        @click="rotateRight"
                        elevation="0"
                        color="#b2b2b2"
                        fab
                        small
                        class="mx-4 white--text">
                        <v-icon>mdi-reload</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog> -->

      <v-dialog v-model="dialog.detail"
        @keydown.esc="dialog.detail = false"
        :fullscreen="dialog.fullscreen"
        width="1000"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Progres Ajuan -
              <span
                :class="selected.detail.log_status === 'BELUM DIVERIFIKASI' ? 'orange--text' :
                        selected.detail.log_status === 'PROSES VERIFIKASI' ? 'blue--text' :
                        selected.detail.log_status === 'DISETUJUI' ? 'cyan--text' :
                        selected.detail.log_status === 'DISETUJUI TANPA NIK' ? 'indigo--text' :
                        selected.detail.log_status === 'DISETUJUI TERBIT NIK' ? 'lime--text' :
                        selected.detail.log_status === 'DIKOREKSI' ? 'purple--text' :
                        selected.detail.log_status === 'SELESAI DIPROSES' ? 'green--text' : 'red--text'">
                {{ selected.title }}
              </span>
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.detail = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text v-if="Object.keys(selected.detail).length > 0"
            class="body-2 font-weight-light text-first line-text-second">
            <div
              class="title black--text font-weight-bold mt-2">
              #{{ selected.detail.log_ajuan_no_reg }}
            </div>

            <div
              class="mb-2">
              {{ selected.detail.log_layanan_kode }} - 

              <span
                :class="selected.detail.log_status === 'BELUM DIVERIFIKASI' ? 'orange--text' :
                        selected.detail.log_status === 'PROSES VERIFIKASI' ? 'blue--text' :
                        selected.detail.log_status === 'DISETUJUI' ? 'cyan--text' :
                        selected.detail.log_status === 'DISETUJUI TANPA NIK' ? 'indigo--text' :
                        selected.detail.log_status === 'DISETUJUI TERBIT NIK' ? 'lime--text' :
                        selected.detail.log_status === 'DIKOREKSI' ? 'purple--text' :
                        selected.detail.log_status === 'SELESAI DIPROSES' ? 'green--text' : 'red--text'">
                {{ selected.detail.log_status }}
              </span>
            </div>

            <div v-if="selected.detail.log_status === 'DITOLAK'"
              class="pa-2 px-3 red--text log_note"
              style="border: 1px solid #fff;
                    border-radius: 7px;
                    border-style: dashed;
                    background: #ff000033;">
              <span
                v-html="selected.detail.log_note">
              </span>
            </div>

            <div
              class="my-3"
              style="opacity: 60%;">
              Tanggal <b>{{ selected.detail.log_create_datetime | date }}</b> Pukul <b>{{ selected.detail.log_create_datetime | time }}</b>
            </div>

            <div
              class="font-weight-bold black--text">
              Nama Lengkap:
            </div>
            
            <div
              class="mb-2">
              {{ selected.detail.log_extra.field.nama_lengkap }}
            </div>

            <div
              class="font-weight-bold black--text">
              NIK:
            </div>
            
            <div
              class="mb-2">
              {{ selected.detail.log_extra.field.nik }}
            </div>

            <div
              class="font-weight-bold black--text">
              Kecamatan:
            </div>
            
            <div
              class="mb-2">
              {{ selected.detail.log_extra.field.kecamatan_name }} ({{ selected.detail.log_extra.field.kecamatan_code }})
            </div>

            <div
              class="font-weight-bold black--text">
              Kelurahan:
            </div>
            
            <div
              class="mb-2">
              {{ selected.detail.log_extra.field.kelurahan_name }} ({{ selected.detail.log_extra.field.kelurahan_code }})
            </div>

            <div
              class="font-weight-bold black--text">
              Keterangan:
            </div>

            <div
              class="mb-2 log_note">
              <span
                v-html="selected.detail.log_note">
              </span>
            </div>

            <div v-if="selected.detail.log_extra.data_dukung.length > 0"
              class="font-weight-bold black--text">
              Data Dukung:
            </div>

            <div
              v-for="(item, index) in selected.detail.log_extra.data_dukung"
              :key="index"
              :class="index < selected.detail.log_extra.data_dukung.length - 1 ? 'mb-2' : ''">
              <div>
                #{{ item.name }}
              </div>

              <v-row>
                <v-col
                  v-for="(item_file, index_file) in item.file"
                  :key="index_file"
                  cols="3">
                  <v-img
                    width="100%"
                  height="180"
                    alt="vuetify"
                    gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                    :src="item_file.url"
                    style="border-radius: 10px;">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          color="#ff64ad">
                        </v-progress-circular>
                      </v-row>
                    </template>

                    <a
                      :href="item_file.url"
                      target="_blank">
                      <v-icon
                        class="cursor-pointer pa-2"
                        size="20"
                        color="white"
                        style="position: absolute;
                              top: 0px;
                              right: 25px;">
                        mdi-download
                      </v-icon>
                    </a>

                    <v-icon 
                      @click="dialog.zoom = true; selected.zoom_file_id = item_file.file_id;"
                      class="cursor-pointer pa-2"
                      size="20"
                      color="white"
                      style="position: absolute;
                            top: 0px;
                            right: 0px;">
                      mdi-fullscreen
                    </v-icon>
                  </v-img>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.verif"
        @keydown.esc="dialog.verif = false"
        :fullscreen="dialog.fullscreen"
        width="750"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Setujui / Tolak Ajuan
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.verif = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <Verification
            :detail="detail"
            @close="dialog.verif = $event"
            @product="selected.menu = $event; fetchDetail();" />
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.update"
        @keydown.esc="dialog.update = false"
        :fullscreen="dialog.fullscreen"
        width="600"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Ubah Status Produk
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.update = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <Update
            :detail="selected.update"
            @close="dialog.update = $event"
            @product="selected.menu = $event; fetchProduct();" />
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.add"
        @keydown.esc="dialog.add = false"
        :fullscreen="dialog.fullscreen"
        width="600"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Tambah Produk
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.add = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <Add
            :detail="selected.add"
            @close="dialog.add = $event"
            @product="selected.menu = $event; fetchProduct();" />
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.reset"
        @keydown.esc="dialog.reset = false"
        :fullscreen="dialog.fullscreen"
        width="500"
        persistent
        scrollable>
        <v-card 
          :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
          class="pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Reset Data
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.reset = false; dialog.fullscreen = false;"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>
          
          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text class="body-1 font-weight-light text-first mt-3">
            Apakah Anda yakin mereset data Ajuan yang Anda pilih?
          </v-card-text>

          <v-alert v-if="message.error.length > 0"
            class="mx-6"
            type="error" 
            dense
            text 
            prominent>
            {{ message.error }}
          </v-alert>

          <v-divider class="mx-4 mb-3 mt-0"/>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="#ff64ad"
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text"
              :disabled="process.form"
              :loading="process.form"
              @click="reset_ajuan()">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Ya, Reset
            </v-btn>

            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text"
              :disabled="process.form"
              @click="dialog.reset = false; dialog.fullscreen = false;">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <section>
        <v-row v-if="process.load && Object.keys(detail).length < 1">
          <v-col 
            cols="12"
            md="3"
            class="pb-0">
            <v-skeleton-loader
              type="image, article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>

          <v-col 
            cols="12"
            md="9"
            class="pb-0">
            <v-skeleton-loader
              type="article, list-item-three-line, article, list-item-three-line, article, article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <div v-if="!process.load && Object.keys(detail).length > 0"
          class="pb-0">
          <v-row>
            <v-col 
              cols="12"
              md="3"
              class="pb-0">
              <div style="position: sticky; top: 96px;">
                <div @click="$router.go(-1)"
                  class="d-flex align-center color-first cursor-pointer mb-4">
                  <v-icon color="#ff64ad">mdi-arrow-left-thick</v-icon>
              
                  <span class="body-1 ml-1">
                    Kembali
                  </span>
                </div>

                <v-card
                  class="my-2 pa-2"
                  style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
                        border-radius: 10px;">
                  <v-card-text
                    class="text-center">
                    Pengaju / Pelapor
                  </v-card-text>

                  <v-card-text
                    class="text-center">
                    <v-avatar 
                      size="125"
                      style="box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;">
                      <v-img
                        width="125"
                        height="125"
                        alt="vuetify"
                        :src="detail.pelapor_image.length < 1 ? require('@/assets/image/member-default.jpg') : detail.pelapor_image">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#ff64ad">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                  </v-card-text>

                  <v-card-title
                    class="d-flex justify-center font-weight-bold">
                    <span
                      class="one-line">
                      {{ detail.pelapor_fullname }}
                    </span>
                  </v-card-title>

                  <v-card-subtitle
                    class="text-center">
                    <div
                      class="my-1">
                      NIK. {{ detail.ajuan_pelapor_nik }}
                    </div>

                    <div
                      class="my-1">
                      Email. {{ detail.ajuan_is_mandiri ? detail.pelapor_email : detail.pelapor_extra.instansi_email }}
                    </div>

                    <div>
                      Telepon. {{ detail.ajuan_is_mandiri ? detail.pelapor_phone : detail.pelapor_extra.instansi_phone }}
                    </div>
                  </v-card-subtitle>

                  <v-card-text
                    class="pb-2">
                    <v-row>
                      <v-col
                        cols="5"
                        class="text-center">
                        <div
                          class="mb-1">
                          Tipe Ajuan
                        </div>

                        <div
                          class="body-1 font-weight-bold"
                          :class="detail.ajuan_is_online ? 'blue--text' : ''">
                          {{ detail.ajuan_is_online ? 'Online' : 'Offline' }}
                        </div>
                      </v-col>

                      <v-col
                        cols="2"
                        class="text-center">
                        <v-divider vertical />
                      </v-col>

                      <v-col
                        cols="5"
                        class="text-center">

                        <div
                          class="mb-1">
                          Kategori Ajuan
                        </div>

                        <div
                          class="body-1 font-weight-bold"
                          :class="detail.ajuan_is_mandiri ? 'green--text' : 'red--text'">
                          <!-- {{ detail.ajuan_is_mandiri ? 'Mandiri' : 'Group' }} -->
                          {{ detail.ajuan_pelapor_role_name }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text v-if="(detail.ajuan_status === 'BELUM DIVERIFIKASI' || detail.ajuan_status === 'DIKOREKSI') && Object.keys(detail.ajuan_extra).length < 1"
                    class="font-italic"
                    style="opacity: 60%;">
                    *Untuk memeriksa berkas ajuan, silahkan menekan tombol <b>"Periksa Berkas Ajuan ?"</b>. Maka untuk ajuan tersebut akan di hold atau tidak bisa diverifikasi oleh operator lain.
                  </v-card-text>

                  <v-card-text v-if="(detail.ajuan_status !== 'BELUM DIVERIFIKASI' || detail.ajuan_status !== 'DIKOREKSI') && Object.keys(detail.ajuan_extra).length > 0"
                    class="pb-0">
                    <div
                      class="font-italic"
                      style="opacity: 60%;">
                      *Ajuan sedang diperiksa / dikerjakan oleh operator berikut:
                    </div>

                    <v-list 
                      flat 
                      color="transparent"
                      three-line>
                      <v-list-item
                        class="mb-0"
                        style="border-radius: 5px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;
                              background: #fff;
                              cursor: auto;">
                        <v-list-item-avatar 
                          tile 
                          size="50"
                          class="mr-3">
                          <v-img 
                            style="border-radius: 5px;"
                            alt="kominfo" 
                            :src="detail.ajuan_extra.admin_proses_verifikasi.image"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="#ff64ad">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title 
                            class="body-2 font-weight-bold">
                            {{ detail.ajuan_extra.admin_proses_verifikasi.fullname }}
                          </v-list-item-title>

                          <v-list-item-subtitle 
                            class="caption font-weight-light black--text">
                            <div
                              class="d-flex align-center"
                              style="margin-bottom: 5px;">
                              <v-icon size="16">mdi-email</v-icon>

                              <span
                                class="one-line ml-1">
                                {{ detail.ajuan_extra.admin_proses_verifikasi.email === '' || detail.ajuan_extra.admin_proses_verifikasi.email === null ? 'xxxx@gmail.com' : detail.ajuan_extra.admin_proses_verifikasi.email }}
                              </span>
                            </div>

                            <div
                              class="d-flex align-center">
                              <v-icon size="16">mdi-phone</v-icon>

                              <span
                                class="one-line ml-1">
                                {{ detail.ajuan_extra.admin_proses_verifikasi.phone === '' || detail.ajuan_extra.admin_proses_verifikasi.phone === null ? 'xxxx-xxxx-xxxx' : detail.ajuan_extra.admin_proses_verifikasi.phone }}
                              </span>
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>

                  <v-card-text
                    v-show="message.error.length > 0"
                    class="py-0 px-2">
                    <v-alert 
                      type="error" 
                      text dense prominent>
                      {{  message.error }}
                    </v-alert>
                  </v-card-text>

                  <v-card-actions v-if="detail.ajuan_status === 'BELUM DIVERIFIKASI' || detail.ajuan_status === 'DIKOREKSI'">
                    <v-btn
                      @click="save()"
                      :loading="process.form"
                      :disabled="process.form"
                      elevation="0"
                      block
                      class="body-2 font-weight-bold text-capitalize white--text"
                      color="orange">
                      <span
                        class="ml-1">
                        Periksa Berkas Ajuan ?
                      </span>

                      <v-spacer />

                      <v-icon>mdi-timer-edit-outline</v-icon>
                    </v-btn>
                  </v-card-actions>

                  <!-- <v-card-actions v-if="detail.ajuan_status === 'PROSES VERIFIKASI' && Object.keys(detail.ajuan_extra).length > 0 && detail.ajuan_extra.admin_proses_verifikasi.id === user.id">
                    <v-btn
                      @click="dialog.verif = true"
                      elevation="0"
                      block
                      class="body-2 font-weight-bold text-capitalize white--text"
                      color="#ff64ad">
                      <span
                        class="ml-1">
                        Verifikasi Sekarang ?
                      </span>

                      <v-spacer />

                      <v-icon>mdi-arrow-right-thick</v-icon>
                    </v-btn>
                  </v-card-actions> -->

                  <v-card-text v-if="detail.ajuan_status === 'PROSES VERIFIKASI' && Object.keys(detail.ajuan_extra).length > 0 && detail.ajuan_extra.admin_proses_verifikasi.id === user.id"
                    class="px-2">
                    <v-btn
                      @click="dialog.verif = true"
                      :disabled="process.form"
                      elevation="0"
                      block
                      class="body-2 font-weight-bold text-capitalize white--text"
                      color="#ff64ad">
                      <span
                        class="ml-1">
                        Verifikasi Sekarang ?
                      </span>

                      <v-spacer />

                      <v-icon>mdi-arrow-right-thick</v-icon>
                    </v-btn>

                    <div
                      class="mt-4">
                      <v-btn
                        @click="save_cancel()"
                        :loading="process.form"
                        :disabled="process.form"
                        elevation="0"
                        outlined
                        block
                        class="body-2 font-weight-bold text-capitalize red--text"
                        color="red">
                        <span
                          class="ml-1">
                          Batalkan Verifikasi
                        </span>

                        <v-spacer />

                        <v-icon>mdi-close-thick</v-icon>
                      </v-btn>
                    </div>
                  </v-card-text>

                  <v-card-text v-if="detail.ajuan_status !== 'BELUM DIVERIFIKASI' && user.level === 'administrator'"
                    class="px-2">
                    <v-btn
                      @click="dialog.reset = true"
                      :disabled="process.form"
                      elevation="0"
                      block
                      class="body-2 font-weight-bold text-capitalize white--text"
                      color="orange">
                      <span
                        class="ml-1">
                        Reset Ajuan
                      </span>

                      <v-spacer />

                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>

            <v-col 
              cols="12"
              md="9"
              class="pb-0"
              :class="detail.ajuan_status === 'BELUM DIVERIFIKASI' || detail.ajuan_status === 'DIKOREKSI' ? 'screen_disabled' : ''">
              <v-tabs
                v-model="selected.menu"
                background-color="transparent"
                color="#ff64ad"
                slider-size="5"
                show-arrows
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                dense
                grow
                class="d-flex justify-start tabs-stream mt-6 ml-6">
                <v-tab
                  v-for="(item, index) in menu"
                  :key="index"
                  class="px-0 mr-4 d-flex align-center">
                  <v-avatar
                    tile
                    size="20">
                    <v-img 
                      contain
                      :src="item.icon">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            size="20"
                            color="#ff64ad">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span 
                    class="body-2 text-capitalize ml-2" 
                    :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                    {{ item.text }}
                  </span>
                </v-tab>
              </v-tabs>
              
              <v-card
                class="pa-2"
                min-height="78vh"
                style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
                      border-radius: 0px 10px 10px 10px;">
                <v-card-title
                  class="text-h5 font-weight-bold mb-1">
                  #{{ detail.ajuan_no_reg }}
                </v-card-title>

                <v-card-subtitle
                  class="mb-2">
                  {{ detail.ajuan_layanan_kode }} - 

                  <span
                    :class="detail.ajuan_status === 'BELUM DIVERIFIKASI' ? 'orange--text' :
                            detail.ajuan_status === 'PROSES VERIFIKASI' ? 'blue--text' :
                            detail.ajuan_status === 'DISETUJUI' ? 'cyan--text' :
                            detail.ajuan_status === 'DISETUJUI TANPA NIK' ? 'indigo--text' :
                            detail.ajuan_status === 'DISETUJUI TERBIT NIK' ? 'lime--text' :
                            detail.ajuan_status === 'DIKOREKSI' ? 'purple--text' :
                            detail.ajuan_status === 'SELESAI DIPROSES' ? 'green--text' : 'red--text'">
                    {{ detail.ajuan_status }}
                  </span>
                </v-card-subtitle>

                <v-card-text
                  :class="selected.menu > 0 ? 'pb-0' : ''"
                  style="opacity: 80%;">
                  <v-icon small>mdi-calendar-month</v-icon>

                  Diajukan pada Tanggal <b>{{ detail.ajuan_create_datetime | date }}</b> Pukul <b>{{ detail.ajuan_create_datetime | time }}</b>
                </v-card-text>

                <!-- INFORMASI AJUAN -->
                <div v-if="selected.menu === 0">
                  <v-card-text>
                    <v-divider
                      style="border: 3px solid #ff64ad;
                          border-radius: 50px;
                          width: 100px;" />
                    
                    <div
                      class="body-1 font-weight-bold black--text my-2">
                      Data Ajuan
                    </div>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="3"
                        class="py-0">
                        Nama Lengkap
                      </v-col>

                      <v-col
                        cols="9"
                        class="py-0">
                        : {{ detail.ajuan_data_ajuan.field.nama_lengkap }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="3"
                        class="py-0">
                        NIK
                      </v-col>

                      <v-col
                        cols="9"
                        class="py-0">
                        : {{ detail.ajuan_data_ajuan.field.nik }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="3"
                        class="py-0">
                        Kecamatan
                      </v-col>

                      <v-col
                        cols="9"
                        class="py-0">
                        : {{ detail.ajuan_data_ajuan.field.kecamatan_name }} ({{ detail.ajuan_data_ajuan.field.kecamatan_code }})
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="3"
                        class="py-0">
                        Kelurahan
                      </v-col>

                      <v-col
                        cols="9"
                        class="py-0">
                        : {{ detail.ajuan_data_ajuan.field.kelurahan_name }} ({{ detail.ajuan_data_ajuan.field.kelurahan_code }})
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="3"
                        class="py-0">
                        Jenis Ajuan
                      </v-col>

                      <v-col
                        cols="9"
                        class="py-0">
                        : {{ detail.ajuan_layanan_kode }} - {{ detail.ja_judul }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="3"
                        class="py-0">
                        Alasan
                      </v-col>

                      <v-col
                        cols="9"
                        class="py-0">
                        : {{ detail.ajuan_keterangan === ''  ? '-' : detail.ajuan_keterangan }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-2">
                      <v-col
                        cols="3"
                        class="py-0">
                        Kelurahan
                      </v-col>

                      <v-col
                        cols="9"
                        class="py-0">
                        : {{ detail.ajuan_kelurahan_name === ''  ? '-' : detail.ajuan_kelurahan_name }}
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        cols="3"
                        class="py-0">
                        Kecamatan
                      </v-col>

                      <v-col
                        cols="9"
                        class="py-0">
                        : {{ detail.ajuan_kecamatan_name === ''  ? '-' : detail.ajuan_kecamatan_name }}
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text v-if="detail.ajuan_data_ajuan.data_dukung.length > 0"
                    class="pb-2">
                    <v-divider
                      style="border: 3px solid #ff64ad;
                          border-radius: 50px;
                          width: 100px;" />
                    
                    <div
                      class="body-1 font-weight-bold black--text my-2 mb-3">
                      Data Dukung
                    </div>

                    <div
                      v-for="(item, index) in detail.ajuan_data_ajuan.data_dukung"
                      :key="index"
                      :class="index < detail.ajuan_data_ajuan.data_dukung.length - 1 ? 'mb-2' : ''">
                      <div>
                        #{{ item.name }}
                      </div>

                      <v-row>
                        <v-col
                          v-for="(item_file, index_file) in item.file"
                          :key="index_file"
                          cols="12"
                          md="3">
                          <v-img
                            width="100%"
                            height="200"
                            alt="vuetify"
                            gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                            :src="item_file.url"
                            style="border-radius: 10px;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="#ff64ad">
                                </v-progress-circular>
                              </v-row>
                            </template>

                            <a
                              :href="item_file.url"
                              target="_blank">
                              <v-icon
                                class="cursor-pointer pa-2"
                                size="30"
                                color="white"
                                style="position: absolute;
                                      top: 0px;
                                      right: 35px;">
                                mdi-download
                              </v-icon>
                            </a>

                            <v-icon 
                              @click="dialog.zoom = true; selected.zoom_file_id = item_file.file_id;"
                              class="cursor-pointer pa-2"
                              size="30"
                              color="white"
                              style="position: absolute;
                                    top: 0px;
                                    right: 0px;">
                              mdi-fullscreen
                            </v-icon>
                          </v-img>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                </div>

                <!-- PROGRES AJUAN -->
                <div v-if="selected.menu === 1">
                  <v-card-text
                    class="pl-0 py-0">
                    <v-timeline
                      align-center
                      dense>
                      <v-timeline-item
                        v-for="(item, index) in process.log ? 5 : list.log"
                        :key="index"
                        :color="item.log_status === 'BELUM DIVERIFIKASI' ? 'orange' :
                                item.log_status === 'PROSES VERIFIKASI' ? 'blue' :
                                item.log_status === 'DISETUJUI' ? 'cyan' :
                                item.log_status === 'DISETUJUI TANPA NIK' ? 'indigo' :
                                item.log_status === 'DISETUJUI TERBIT NIK' ? 'lime' :
                                item.log_status === 'DIKOREKSI' ? 'purple' :
                                item.log_status === 'SELESAI DIPROSES' ? 'green' : 'red'"
                        small>
                        <v-skeleton-loader
                          :loading="process.log"
                          type="list-item-avatar-three-line">
                          <div>
                            <v-row v-if="!process.log && list.log.length > 0"
                              @click="selected.detail = item; selected.title = item.log_status; dialog.detail = true;"
                              class="cursor-pointer">
                              <v-col 
                                cols="2">
                                <div
                                  class="body-1 font-weight-bold black--text"
                                  style="opacity: 60%;">
                                  {{ item.log_create_datetime | time }}
                                </div>
                              </v-col>

                              <v-col
                                cols="10">
                                <div
                                  class="body-1 font-weight-bold"
                                  :class="item.log_status === 'BELUM DIVERIFIKASI' ? 'orange--text' :
                                          item.log_status === 'PROSES VERIFIKASI' ? 'blue--text' :
                                          item.log_status === 'DISETUJUI' ? 'cyan--text' :
                                          item.log_status === 'DISETUJUI TANPA NIK' ? 'indigo--text' :
                                          item.log_status === 'DISETUJUI TERBIT NIK' ? 'lime--text' :
                                          item.log_status === 'DIKOREKSI' ? 'purple--text' :
                                          item.log_status === 'SELESAI DIPROSES' ? 'green--text' : 'red--text'">
                                  {{ item.log_status }}
                                </div>

                                <div
                                  class="body-2 font-weight-light line-text-second my-1 log_note"
                                  style="opacity: 60%;">
                                  <span
                                    v-html="item.log_note">
                                  </span>
                                </div>

                                <div 
                                  class="body-2 font-weight-bold black--text"
                                  style="opacity: 60%;">
                                  {{ item.log_create_datetime | date }}
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-skeleton-loader>
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </div>

                <!-- PRODUK AJUAN -->
                <div v-if="selected.menu === 2">
                  <v-card-text>
                    <v-btn v-if="!process.product && pagination.product.total_data > 0 && detail.ajuan_status !== 'SELESAI DIPROSES'"
                      @click="dialog.add = true; selected.add = detail;"
                      elevation="0"
                      style="background: #00acc133;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1 my-4">
                      <v-icon size="18">mdi-plus-circle-outline</v-icon>

                      <span class="ml-1">
                        Tambah Produk
                      </span>
                    </v-btn>

                    <v-list 
                      flat 
                      color="transparent"
                      three-line>
                      <v-list-item-group>
                        <v-skeleton-loader
                          v-for="(item, index) in process.product ? 5 : list.product"
                          :key="index"
                          class="ma-auto"
                          :loading="process.product"
                          type="list-item-avatar-three-line">
                          <template>
                            <div>
                              <v-list-item v-if="!process.product && list.product.length > 0"
                                :class="index < list.product.length - 1 ? 'mb-4' : ''"
                                class="pl-3"
                                style="border-radius: 5px;
                                      border: 2px solid #eaeaea; 
                                      border-style: dashed;
                                      background: #fff;
                                      cursor: auto;">
                                <v-list-item-avatar 
                                  tile 
                                  size="50"
                                  class="mr-3">
                                  <v-img 
                                    style="border-radius: 5px;"
                                    alt="kominfo" 
                                    :src="require(`@/assets/image/service/${item.prod_layanan_kode}.png`)"
                                    class="ma-auto">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          indeterminate 
                                          color="#ff64ad">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                  <v-list-item-title 
                                    class="body-2 font-weight-bold">
                                    {{ item.prod_layanan_kode }} - {{ item.prod_nomor }}
                                  </v-list-item-title>

                                  <v-list-item-subtitle 
                                    class="caption font-weight-light black--text my-2" 
                                    style="opacity: 60%;">
                                    <div
                                      style="margin-bottom: 7px;">
                                      <span
                                        class="one-line text-uppercase">
                                        {{ item.prod_nama }}
                                      </span>
                                    </div>

                                    <div
                                      class="font-weight-bold"
                                      :class="item.prod_status === 'BELUM DIVERIFIKASI' || item.prod_status === 'BELUM DIAJUKAN TTE' ? 'orange--text' :
                                              item.prod_status === 'TIDAK DIPROSES' ? 'red--text' : 'cyan--text'">
                                      <span
                                        class="one-line">
                                        {{ item.prod_status }}
                                      </span>
                                    </div>
                                  </v-list-item-subtitle>

                                  <v-list-item-subtitle 
                                    class="caption font-weight-light black--text">
                                    <span
                                      class="one-line">
                                      {{ item.prod_create_datetime | date }}
                                    </span>
                                  </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action
                                  class="d-flex align-center">
                                  <v-btn v-if="item.prod_status === 'BELUM DIVERIFIKASI' || item.prod_status === 'BELUM DIAJUKAN TTE'"
                                    @click="dialog.update = true; selected.update = item;"
                                    width="80"
                                    small
                                    elevation="0"
                                    style="background: #00acc133;"
                                    class="caption text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1 px-2">
                                    <v-icon small>mdi-checkbox-marked-circle-outline</v-icon>
                                    
                                    <span
                                      class="ml-1">
                                      Proses
                                    </span>
                                  </v-btn>

                                  <v-btn v-if="item.prod_status !== 'BELUM DIVERIFIKASI' && item.prod_status !== 'BELUM DIAJUKAN TTE'"
                                    :to="`/product/${detail.ajuan_layanan_kode}/${item.prod_ajuan_id}`"
                                    width="80"
                                    small
                                    elevation="0"
                                    style="background: #e0e0e0;"
                                    class="caption text-capitalize font-weight-bold d-flex align-center text-second px-2">
                                    <v-icon small>mdi-text-box-check-outline</v-icon>
                                    
                                    <span
                                      class="ml-1">
                                      Detail
                                    </span>
                                  </v-btn>
                                </v-list-item-action>
                              </v-list-item>
                            </div>
                          </template>
                        </v-skeleton-loader>
                      </v-list-item-group>
                    </v-list>

                    <Empty v-if="!process.product && pagination.product.total_data < 1"
                      margin="my-10"
                      padding="pa-16"
                      font="body-2"
                      :size="150"
                      message="Produk" />
                  </v-card-text>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>
    </v-flex>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        rotation: 0,
        dialog: {
          fullscreen: false,
          zoom: false,
          detail: false,
          verif: false,
          update: false,
          add: false,

          reset: false
        },
        selected: {
          title: '',
          zoom_index: 0,
          zoom_file_id: '',
          zoom_array: [],
          menu: 0,
          detail: {},
          update: {},
          add: {}
        },
        menu: [
          {
            text: 'Informasi',
            icon: require('@/assets/image/info.png')
          },
          {
            text: 'Progres',
            icon: require('@/assets/image/step.png')
          },
          {
            text: 'Produk',
            icon: require('@/assets/image/box.png')
          }
        ],
        detail: {},
        list: {
          log: [],
          product: []
        },
        pagination: {
          log: {},
          product: {}
        },
        process: {
          load: false,
          log: false,
          product: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Verification: () => import(/* webpackPrefetch: true */ '@/components/verification/dialog.vue'),
      Add: () => import(/* webpackPrefetch: true */ '@/components/verification/add.vue'),
      Update: () => import(/* webpackPrefetch: true */ '@/components/verification/update.vue'),
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'selected.menu': function(val) {
        if (val === 1) {
          this.fetchLog()
        } else if (val === 2) {
          this.fetchProduct()
        }
      },
      'selected.zoom_file_id':function(val) {
        this.selected.zoom_index = this.selected.zoom_array.findIndex(x => x.file_id === val)
      },
      'selected.zoom_index':function() {
        this.rotation = 0
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        this.selected.zoom_array = []

        await get(`admin/ajuan/${this.$route.path.split('/')[2]}/detail`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.load = false
            
            this.detail = res.data

            let arr = this.detail.ajuan_data_ajuan.data_dukung

            arr.map(obj => {
              obj.file.map(obj_file => {
                this.selected.zoom_array.push({
                  title: obj.name,
                  file: obj_file.url,
                  file_id: obj_file.file_id
                })
              })
            })
          }
        })
      },
      async fetchLog () {
        this.process.log = true
        
        let params = {
          log_ajuan_id: this.detail.ajuan_id
        }

        await get(`ajuan/${this.detail.ajuan_layanan_kode}/log`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.log = false
            
            this.list.log = res.data
            this.pagination.log = res.pagination
          }
        })
      },
      async fetchProduct () {
        this.process.product = true
        
        let params = {
          prod_ajuan_id: this.detail.ajuan_id,
          order_by: 'ASC'
        }

        await get(`admin/produk/list`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.product = false
            
            this.list.product = res.data
            this.pagination.product = res.pagination
          }
        })
      },

      // PROSES VERIFIKASI
      async save () {
        this.message.error = ''

        this.process.form = true

        let forms = {
          id: this.detail.ajuan_id,
          no_reg: this.detail.ajuan_no_reg,
          status: 'PROSES VERIFIKASI'
        }

        // SAVE TO REST API
        await post(`admin/ajuan/${this.detail.ajuan_layanan_kode}/update_status`, {
          data: forms
        })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.form = false
            
            this.fetchDetail()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      },
      rotateRight() {
        this.rotation += 90
      },
      rotateLeft() {
        this.rotation -= 90
      },

      // PROSES BATAL VERIFIKASI
      async save_cancel () {
        this.message.error = ''

        this.process.form = true

        let forms = {
          id: this.detail.ajuan_id
        }

        // SAVE TO REST API
        await post(`admin/ajuan/${this.detail.ajuan_layanan_kode}/update_status_proses_verifikasi_batal`, {
          data: forms
        })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.form = false
            
            this.fetchDetail()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      },

      // RESET AJUAN
      async reset_ajuan () {
        this.message.error = ''

        this.process.form = true

        let forms = {
          id: this.detail.ajuan_id,
          no_reg: this.detail.ajuan_no_reg
        }

        // SAVE TO REST API
        await post(`admin/ajuan/reset_ajuan_to_first_step`, {
          data: forms
        })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.form = false

            this.dialog.reset = false
            
            this.fetchDetail()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  .v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
    min-height: 64vh;
    left: calc(24px - 1px);
  }

  .v-timeline-item__divider {
    min-width: 50px;
    justify-content: start !important;
    left: -34px;
  }

  .log_note p {
    margin-bottom: 2px;
  }
</style>